import isArray from "lodash/isArray";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CustomValuesEditFieldProps } from "./custom_values_edit_field.types";
import { getCanEditCustomFieldData } from "./custom_values_edit_field.utils";

type UseCommonProps = Pick<
  CustomValuesEditFieldProps,
  | "adminPage"
  | "customType"
  | "profile"
  | "position"
  | "isActivity"
  | "activityCreator"
  | "forceUnlocked"
  | "label"
  | "title"
  | "errors"
  | "placeholder"
  | "tip"
  | "kind"
  | "disabled"
  | "required"
  | "variant"
  | "tabIndex"
  | "style"
>;

export const useCommonProps = ({
  adminPage,
  customType,
  profile,
  position,
  isActivity,
  activityCreator,
  forceUnlocked,
  label,
  title,
  errors,
  placeholder,
  tip,
  kind,
  disabled,
  required,
  variant,
  tabIndex,
  style
}: UseCommonProps) => {
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation();

  const { locked, lockedTip } = useMemo(
    () =>
      getCanEditCustomFieldData({
        customType,
        adminPage,
        forceUnlocked,
        isActivity,
        activityCreator,
        position,
        profile,
        currentProfile,
        t
      }),
    [customType, adminPage, forceUnlocked, isActivity, activityCreator, position, profile, currentProfile, t]
  );

  return useMemo(
    () => ({
      kind,
      error: isArray(errors) ? errors[0] : errors,
      label: label ?? customType?.display_as,
      title,
      placeholder,
      tip: tip ?? customType?.description,
      locked,
      lockedTip,
      disabled,
      required,
      variant,
      tabIndex,
      style
    }),
    [
      kind,
      errors,
      label,
      customType?.display_as,
      customType?.description,
      title,
      placeholder,
      tip,
      disabled,
      required,
      locked,
      lockedTip,
      variant,
      tabIndex,
      style
    ]
  );
};
